export const catalog_matrix = [
  {form_key:'new_insurance_carrier_id', catalog_key:'insurance_carriers'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]